import { render, staticRenderFns } from "./Quicklooks.vue?vue&type=template&id=a84d97ba&scoped=true"
import script from "./Quicklooks.vue?vue&type=script&lang=js"
export * from "./Quicklooks.vue?vue&type=script&lang=js"
import style0 from "./Quicklooks.vue?vue&type=style&index=0&id=a84d97ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84d97ba",
  null
  
)

export default component.exports